import { Routes } from '@angular/router';
import { MachineComponent } from './machine.component';
import { SalesComponent } from './sales/sales.component';
import { LogsComponent } from './logs/logs.component';
import { EventsComponent } from './events/events.component';
import { UpdatesComponent } from './updates/updates.component';
import { OpenIssuesComponent } from './open-issues/open-issues.component';
import { RemoteCtrlComponent } from './remote-ctrl/remote-ctrl.component';
import { MachineDetailsComponent } from './machine-details/machine-details.component';
import { RoleGuardService } from '../../../../app/core/_guard/role-guard.service';
import { FeatureFlagGuardService } from '../../../../app/core/_guard/feature-flag-guard.service';
import { SignalStrengthComponent } from './signal-strength/signal-strength.component';
import { ConnectionLogsComponent } from './connection-logs/connection-logs.component';
import { InventoryComponent } from './inventory/inventory.component';
import { InventoryLocationComponent } from './inventory-location/inventory-location.component';
import { SettingsComponent } from './settings/settings.component';
import { PriceChangeComponent } from './price-change/price-change.component';
import { CardReaderComponent } from './card-reader/card-reader.component';
import { MachineColdBrewComponent } from './cold-brew/machine-cold-brew.component';
import { AugerPurgeComponent } from './auger-purge/auger-purge.component';
import { CanisterTypeComponent } from './canister-type/canister-type.component';
var ɵ0 = { roles: ['sadmin', 'admin'] }, ɵ1 = { roles: ['sadmin', 'admin'] }, ɵ2 = { roles: ['sadmin'] }, ɵ3 = { roles: ['sadmin'] }, ɵ4 = { roles: ['sadmin', 'marketadmin'], featureFlag: 'card_reader_registration' }, ɵ5 = { roles: ['sadmin'], featureFlag: 'cold_brew' };
var genRoutes = [
    { path: '', component: MachineComponent, children: [
            { path: '', redirectTo: 'inventory', pathMatch: 'full' },
            { path: 'sales', component: SalesComponent },
            { path: 'logs', component: LogsComponent },
            { path: 'inventory', component: InventoryComponent },
            { path: 'location-inventory', component: InventoryLocationComponent },
            { path: 'events', component: EventsComponent },
            { path: 'updates', component: UpdatesComponent },
            { path: 'remote', component: RemoteCtrlComponent, canActivate: [RoleGuardService], data: ɵ0 },
            { path: 'signal', component: SignalStrengthComponent },
            { path: 'conn-log', component: ConnectionLogsComponent },
            { path: 'details', component: MachineDetailsComponent, data: ɵ1 },
            { path: 'open-issues', component: OpenIssuesComponent },
            { path: 'settings', component: SettingsComponent },
            { path: 'auger-purge', component: AugerPurgeComponent, canActivate: [RoleGuardService], data: ɵ2 },
            {
                path: 'canister-type',
                component: CanisterTypeComponent,
                canActivate: [RoleGuardService],
                data: ɵ3
            },
            { path: 'price-change', component: PriceChangeComponent },
            {
                path: 'card-reader',
                component: CardReaderComponent,
                canActivate: [RoleGuardService, FeatureFlagGuardService],
                data: ɵ4
            },
            { path: 'cold-brew', component: MachineColdBrewComponent, canActivate: [RoleGuardService, FeatureFlagGuardService], data: ɵ5 }
        ] }
];
var MachineRoutingModule = /** @class */ (function () {
    function MachineRoutingModule() {
    }
    return MachineRoutingModule;
}());
export { MachineRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
